<script>
const CONFIRMATION_STATES = [
  'approval-requested',
  'approval-responded',
  'output-denied',
  'output-available',
  'input-streaming',
  'input-available',
];
</script>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  state: {
    type: String,
    required: true,
    validator: value => CONFIRMATION_STATES.includes(value),
  },
  approved: {
    type: Boolean,
    default: undefined,
  },
});

const isRespondedState = computed(() =>
  ['approval-responded', 'output-denied', 'output-available'].includes(
    props.state
  )
);

const showRoot = computed(
  () => props.state !== 'input-streaming' && props.state !== 'input-available'
);

const showRequest = computed(() => props.state === 'approval-requested');

const showAccepted = computed(
  () => props.approved === true && isRespondedState.value
);

const showRejected = computed(
  () => props.approved === false && isRespondedState.value
);

const showActions = computed(() => props.state === 'approval-requested');

const isCompactLog = computed(() => showAccepted.value || showRejected.value);
</script>

<template>
  <template v-if="showRoot">
    <!-- Compact log row after approve/deny — no card chrome -->
    <div v-if="isCompactLog" class="space-y-1">
      <slot v-if="showAccepted" name="accepted" />
      <slot v-else-if="showRejected" name="rejected" />
    </div>

    <!-- Request card with actions -->
    <div
      v-else
      class="flex flex-col gap-2 rounded-xl ring-1 ring-n-weak bg-n-solid-2 p-4"
    >
      <div v-if="$slots.title && showRequest" class="text-sm text-n-slate-12">
        <slot name="title" />
      </div>

      <div v-if="showRequest && $slots.request" class="text-sm text-n-slate-11">
        <slot name="request" />
      </div>

      <div
        v-if="showActions && $slots.actions"
        class="flex flex-wrap items-center justify-end gap-2 self-end"
      >
        <slot name="actions" />
      </div>
    </div>
  </template>
</template>
